// extracted by mini-css-extract-plugin
export default {"tableAvatar":"PerformanceSummaryTable_tableAvatar__1z5OY","tableAvatar__img":"PerformanceSummaryTable_tableAvatar__img__MEe7W","rank":"PerformanceSummaryTable_rank__1RXJs"};